import React from "react";
import { observer } from "mobx-react";
import DisplayComment from "@app/components/comments/comment";

const Comment = observer(({ data }) => {
    return <DisplayComment comment={data} readonly={true} />;
});

export default Comment;
